/* eslint-disable max-lines */

import LoadingIndicator from 'components/LoadingIndicator';
import LoadingOverlay from 'react-loading-overlay-ts';

import EmptyTableState from 'components/EmptyTableState';
import LocalListFooter from 'components/ListFooter/LocalListFooter';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getActiveCohortAuditLogsBatches,
  getCohortsLoading,
  getSingleCohortLoading,
} from 'selectors/cohorts';
import CohortAuditLogsListItem from './CohortAuditLogsListItem';

const CohortAuditoLogsList: React.FC = () => {
  const loading = useSelector(getCohortsLoading);

  const audtiLogsBatches = useSelector(getActiveCohortAuditLogsBatches);

  const [paginationParams, setPaginationParams] = useState<{ offset: number; limit: number }>({
    limit: 25,
    offset: 0,
  });

  const isEmpty = audtiLogsBatches.length === 0;

  return (
    <div className="table-wrapper__new no-scrollbar overflow-auto">
      <LoadingOverlay
        active={loading}
        spinner={<LoadingIndicator size="10" />}
        className="relative w-full h-full"
        fadeSpeed={0}
        styles={{
          content: (base) => ({
            ...base,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }),
          wrapper: () => ({}),
          spinner: () => ({}),
          overlay: (base) => ({
            ...base,
            zIndex: 10,
          }),
        }}
      >
        <table className="table-wrapper__table table-wrapper_table--fixed">
          <thead className="sticky top-0 z-10">
            <tr className="table-wrapper__header-tr h-10">
              <th aria-hidden className="table-wrapper__new-th table-wrapper__th--w-3" />
              <th className="table-wrapper__new-th table-wrapper__th--w-13">Change Logged</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-16">Insight Assigned</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-16">Prevent Assigned</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-16">Insight Transfer</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-16">Prevent Transfer</th>
              <th className="table-wrapper__new-th p-0">Notes</th>
            </tr>
          </thead>
          <tbody className="table-wrapper__tbody">
            {!loading && isEmpty ? (
              <EmptyTableState message="There are no logs to display" colCount="7" />
            ) : (
              audtiLogsBatches
                .slice(paginationParams.offset, paginationParams.offset + paginationParams.limit)
                .map((batch) => <CohortAuditLogsListItem key={batch.uuid} auditLogBatch={batch} />)
            )}
          </tbody>
        </table>
        <div className="border-t border-gray-200 sticky bottom-0 z-10 bg-white">
          <LocalListFooter
            resourceName="Item"
            getResourceLoading={getSingleCohortLoading}
            paginationParams={paginationParams}
            totalCount={audtiLogsBatches.length}
            setPaginationParams={setPaginationParams}
          />
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default CohortAuditoLogsList;
